import { useEffect } from "react";
import { numToCurrency, decimToPercent } from "../utils/transformators";
import * as Calculations from "../utils/calculations";
import useUSPosition from "../../../hooks/useUSPosition";
import { useLocation } from "react-router-dom";

const useCalculations = (USpositionData, paymenttermData) => {
  //General
  const location = useLocation();
  // Load context values
  const { setUSposition, setUSpositionData, positiontoedit } = useUSPosition();
  useEffect(() => {
    const docalcs = async () => {
      // totalinboundcalc
      let ttloutbound = await Calculations.sumvalues(
        USpositionData.outdrayage,
        USpositionData.loading,
        USpositionData.outcollectcharges,
        USpositionData.outboundothers
      );
      // outboundpmtcalc
      const outbpmt = await Calculations.dividevalues(ttloutbound, USpositionData?.outpayload);
      //  materialvaluecalc
      const matvalue = await Calculations.multiplyvalues(USpositionData.quantity, USpositionData.materialcost);
      // totaldutycalc
      const ttlduty = await Calculations.sumvalues(USpositionData.generaldutyimp, USpositionData.additionaldutyimp);
      // dutyfeecalc
      const dtyfee = await Calculations.multiplyvalues(matvalue, ttlduty);
      // harborfeecalc
      const hbrfee = await Calculations.multiplyvalues(matvalue, USpositionData.harborfeepct);
      // merchprocfeecalc
      const mrcfee = await Calculations.multiplyvalues(matvalue, USpositionData.merchprocfeepct);
      // totalcentryfeecalc
      const ttlcentryfee = await Calculations.sumvalues(
        dtyfee,
        hbrfee,
        mrcfee,
        USpositionData.flatfee,
        USpositionData.tsca,
        USpositionData.isf
      );
      // centryfeepmtcalc
      const centrypmt = await Calculations.dividevalues(ttlcentryfee, USpositionData.quantity);
      // totalinboundcalc
      const ttlinbound = await Calculations.sumvalues(
        USpositionData.indrayage,
        USpositionData.unloading,
        USpositionData.incollectcharges,
        USpositionData.inboundothers
      );
      // inboundpmtcalc
      const inbpmt = await Calculations.dividevalues(ttlinbound, USpositionData.inpayload);
      // freightpmtcalc
      const frtpmt = await Calculations.dividevalues(USpositionData.oceanfreight, USpositionData.oceanpayload);
      // totalcostcalc
      const ttlcost = await Calculations.sumvalues(
        USpositionData.materialcost,
        outbpmt,
        centrypmt,
        inbpmt,
        USpositionData.pcomission,
        USpositionData.pfinancecost,
        frtpmt,
        USpositionData.inspectioncost,
        USpositionData.legal,
        USpositionData.pallets,
        USpositionData.other
      );
      console.log(USpositionData.interest);
      // insurcalc
      const inscost = await Calculations.multiplyvalues(
        ttlcost,
        USpositionData.insurancerate,
        USpositionData.insurancefactor
      );
      // interestcostcalc
      const intercost = await Calculations.interestcostcalc(ttlcost, paymenttermData, USpositionData?.interest);
      // finalpricecalc
      const paii = await Calculations.sumvalues(ttlcost, intercost, inscost);

      setUSposition((prev) => ({
        ...prev,
        ["totalcost"]: numToCurrency(ttlcost),
        ["interestcost"]: numToCurrency(intercost),
        ["insurancecost"]: numToCurrency(inscost),
        ["priceafterintins"]: numToCurrency(paii),
        ["materialvalue"]: numToCurrency(matvalue),
        ["totalduty"]: decimToPercent(ttlduty),
        ["dutyfee"]: numToCurrency(dtyfee),
        ["harborfee"]: numToCurrency(hbrfee),
        ["merchprocfee"]: numToCurrency(mrcfee),
        ["totalcentryfee"]: numToCurrency(ttlcentryfee),
        ["importcustomsfee"]: numToCurrency(centrypmt),
        ["totalinbound"]: numToCurrency(ttlinbound),
        ["inboundcost"]: numToCurrency(inbpmt),
        ["totaloutbound"]: numToCurrency(ttloutbound),
        ["outboundcost"]: numToCurrency(outbpmt),
        ["freightpmt"]: numToCurrency(frtpmt),
      }));
      setUSpositionData((prev) => ({
        ...prev,
        ["totalcost"]: ttlcost,
        ["interestcost"]: intercost,
        ["insurancecost"]: inscost,
        ["priceafterintins"]: paii,
        ["materialvalue"]: matvalue,
        ["totalduty"]: ttlduty,
        ["dutyfee"]: dtyfee,
        ["harborfee"]: hbrfee,
        ["merchprocfee"]: mrcfee,
        ["totalcentryfee"]: ttlcentryfee,
        ["importcustomsfee"]: centrypmt,
        ["totalinbound"]: ttlinbound,
        ["inboundcost"]: inbpmt,
        ["totaloutbound"]: ttloutbound,
        ["outboundcost"]: outbpmt,
        ["freightpmt"]: frtpmt,
      }));
    };
    docalcs();
  }, [
    USpositionData.generaldutyimp,
    USpositionData.additionaldutyimp,
    USpositionData.quantity,
    USpositionData.materialcost,
    USpositionData.pcomission,
    USpositionData.pfinancecost,
    USpositionData.freightpmt,
    USpositionData.inspectioncost,
    USpositionData.legal,
    USpositionData.pallets,
    USpositionData.other,
    USpositionData.interest,
    paymenttermData,
    USpositionData.insurancefactor,
    USpositionData.insurancerate,
    USpositionData.harborfeepct,
    USpositionData.merchprocfeepct,
    USpositionData.flatfee,
    USpositionData.tsca,
    USpositionData.isf,
    USpositionData.indrayage,
    USpositionData.unloading,
    USpositionData.incollectcharges,
    USpositionData.inboundothers,
    USpositionData.inpayload,
    USpositionData?.outdrayage,
    USpositionData?.loading,
    USpositionData?.outcollectcharges,
    USpositionData?.outboundothers,
    USpositionData?.outpayload,
    USpositionData.oceanfreight,
    USpositionData.oceanpayload,
    positiontoedit,
    location.key,
  ]);
};

export default useCalculations;
